import { render, staticRenderFns } from "./myPicList.vue?vue&type=template&id=87bb0d40&scoped=true&"
import script from "./myPicList.vue?vue&type=script&lang=js&"
export * from "./myPicList.vue?vue&type=script&lang=js&"
import style0 from "./myPicList.vue?vue&type=style&index=0&id=87bb0d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bb0d40",
  null
  
)

export default component.exports